<script lang="ts" setup>
import { computed, ref, toRefs } from 'vue';

import OpenOrdersItemMobile from './OpenOrdersItemMobile.vue';
import MyOrdersListMobile from '../../components/MyOrdersListMobile.vue';
import { useOrdersListActive, useOrdersListMobile } from '../../useOrdersList';

const props = defineProps({
  authenticatedUser: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
  showOrderType: { type: Boolean, required: true },
});

const { marketId } = toRefs(props);

const useFocusedOrders = () => {
  const focusedOrderIds = ref<Array<string>>([]);

  const isOrderFocused = (id: string) => focusedOrderIds.value.includes(id);

  const toggleFocusForOrder = (id: string) => {
    if (focusedOrderIds.value.includes(id)) {
      focusedOrderIds.value.splice(focusedOrderIds.value.indexOf(id), 1);
    } else {
      focusedOrderIds.value.push(id);
    }
  };

  return {
    isOrderFocused,
    toggleFocusForOrder,
  };
};

const { activeOrdersDataToShow, getOrderById, getLimitedActiveOrdersDataToShow } = useOrdersListActive(marketId);

const { mobileHeader, cancelOrder } = useOrdersListMobile();
const { isOrderFocused, toggleFocusForOrder } = useFocusedOrders();

const showInfo = computed(() => Boolean(!activeOrdersDataToShow.value.allOrders.length));
</script>

<template>
  <my-orders-list-mobile
    class="open-orders-list-mobile"
    :authenticated-user="authenticatedUser"
    :market-id="marketId"
    :mobile-header="[]"
    :show-all-markets="showAllMarkets"
    :show-info="showInfo"
    :is-filled-list="false"
    :show-order-type="showOrderType"
  >
    <template #list="{ itemClass }">
      <template v-for="item in getLimitedActiveOrdersDataToShow(activeOrdersDataToShow.allOrders)">
        <open-orders-item-mobile
          v-if="getOrderById(item.orderId)"
          :key="item.key"
          :class="itemClass"
          :is-current-market-order="marketId === item.instrumentCode"
          :show-order-type="showOrderType"
          :swipe-area-visible="isOrderFocused(item.orderId)"
          :order="getOrderById(item.orderId)"
          :cancel-order="cancelOrder"
          :is-futures="marketId.endsWith('_P')"
          @click="toggleFocusForOrder(item.orderId)"
        />
      </template>
    </template>
  </my-orders-list-mobile>
</template>
